<template>
  <g fill="#ADADAD">
    <path d="M2.5 7.5h15v1h-15zM2.5 9.5h15v1h-15zM2.5 11.5h15v1h-15z" />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HandleIcon",
});
</script>
